import React, {Component} from "react"
import PropTypes from "prop-types";

/** Context wrapper for providing the angular injector down to react components.
 *
 * Use by wrapping your react root in an injector provider that has an instance of the injector
 *
 *
 * class MyComponent extends React.Component {
 *
 *     render() {
 *        return <div>{this.props.$injector.get('myAngularService').getSomeValue()}</div>
 *     }
 * }
 *
 * const MyComponentWithInjector = withInjector(MyComponent)
 *
 * <InjectorProvider $injector={$injector}>
 *     <div class="foo">
 *         <div> class="bar">
 *             <MyComponentWithInjector baz="blah"/>
 *         </div>
 *     </div>
 * </InjectorProvider>
 *
 *
 * */
export class InjectorProvider extends Component {

  getChildContext() {
    return { $injector: this.props.$injector }
  }
  render() {
    // `Children.only` enables us not to add a <div /> for nothing
    return React.Children.only(this.props.children)
  }
}


InjectorProvider.propTypes = {
  $injector: PropTypes.object.isRequired
}
// you must specify what you’re adding to the context
InjectorProvider.childContextTypes = {
  $injector: PropTypes.object.isRequired
}

export const withInjector = (ComponentToWrap) => {
  class WithInjectionsComponent extends Component {
    render() {
      return (
        <ComponentToWrap {...this.props} $injector={this.context.$injector} />
      )
    }
  }
  WithInjectionsComponent.contextTypes = {
    $injector: PropTypes.object.isRequired,
  }
  return WithInjectionsComponent
}
